import React from 'react';
import Footer from './components/footer/Footer';
import Header from './components/header/Header';
import Main from './container/Main';
import './App.css';

const App = () => {
  return (
    <>
      <Header />
      <Main />
      <Footer />
    </>
  )
}

export default App;